import React from "react";
import '../../../styles/Resume.css';
import resume from '../../../assets/Karthikgohul_Developer.pdf';
import resumeSVG from '../../../assets/images/resume.svg';

const Resume = () => {
  return (
    <>
      <div className="Resume">
        <div className="ResumeDetails">
          <div className="resumeSVG">
            <img src={resumeSVG} alt="Resume Illustration SVG" />
          </div>
          <div className="resumeDownload">
          <h3>Click Here to Download Resume</h3>
          <button className="resumeBtn"><a href={resume} target="_blank" rel="noreferrer">Click Here</a></button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Resume;
